import { t as e } from "../../utils-DiFe-_ei.js";
import { a as t, i as n, n as r, o as i, r as a, s as o, t as s, u as c } from "../../alert-dialog-Ca8qCttL.js";
import { Button as l, buttonVariants as u } from "../../foundations/button.js";
import "../../button-C8zrAH2m.js";
import "../../alert-dialog-D-VweTRh.js";
import { Dialog as d, DialogContent as f, DialogDescription as p, DialogFooter as m, DialogHeader as h, DialogTitle as g } from "../../foundations/dialog.js";
import "../../dialog-DGSJCBAd.js";
import { Sheet as _, SheetContent as v, SheetDescription as y, SheetHeader as b, SheetTitle as x } from "../../foundations/sheet.js";
import "../../sheet-CvqhDCEw.js";
import { Skeleton as S } from "../../foundations/skeleton.js";
import "../../skeleton-bhKtal4a.js";
import { useEffect as C, useRef as w } from "react";
import { jsx as T, jsxs as E } from "react/jsx-runtime";
//#region src/components/overlays/ConfirmDialog/ConfirmDialog.tsx
function D({ open: l, onOpenChange: d, title: f, description: p, children: m, confirmLabel: h, pendingLabel: g, cancelLabel: _ = "Cancel", tone: v = "default", isPending: y = !1, closeOnConfirm: b = !0, onConfirm: x }) {
	function S(e) {
		!e && !b && y || d(e);
	}
	return /* @__PURE__ */ T(s, {
		open: l,
		onOpenChange: S,
		children: /* @__PURE__ */ E(n, { children: [
			/* @__PURE__ */ E(o, { children: [/* @__PURE__ */ T(c, { children: f }), typeof p == "string" ? /* @__PURE__ */ T(t, { children: p }) : p ? /* @__PURE__ */ T(t, {
				asChild: !0,
				children: /* @__PURE__ */ T("div", { children: p })
			}) : null] }),
			m,
			/* @__PURE__ */ E(i, { children: [/* @__PURE__ */ T(a, {
				disabled: y && !b,
				children: _
			}), /* @__PURE__ */ T(r, {
				onClick: (e) => {
					b || e.preventDefault(), x();
				},
				disabled: y,
				className: e(v === "destructive" && u({ variant: "destructive" })),
				children: y ? g ?? h : h
			})] })
		] })
	});
}
//#endregion
//#region src/components/overlays/HtmlPreviewSheet/HtmlPreviewSheet.tsx
function O({ open: e, onOpenChange: t, title: n, description: r, html: i }) {
	let a = w(null);
	function o() {
		let e = a.current?.contentWindow;
		e && e.addEventListener("keydown", (e) => {
			e.key === "Escape" && t(!1);
		});
	}
	return /* @__PURE__ */ T(_, {
		open: e,
		onOpenChange: t,
		children: /* @__PURE__ */ E(v, {
			side: "right",
			className: "w-[min(95vw,1100px)] max-w-none sm:max-w-none",
			children: [/* @__PURE__ */ E(b, { children: [/* @__PURE__ */ T(x, { children: n }), /* @__PURE__ */ T(y, {
				className: "sr-only",
				children: r
			})] }), /* @__PURE__ */ T("div", {
				className: "min-h-0 flex-1 p-4",
				children: i ? /* @__PURE__ */ T("iframe", {
					ref: a,
					onLoad: o,
					sandbox: "allow-same-origin",
					srcDoc: i,
					className: "h-full w-full rounded-lg border-0",
					title: n
				}) : /* @__PURE__ */ T(S, { className: "h-full w-full rounded-lg" })
			})]
		})
	});
}
//#endregion
//#region src/components/overlays/FormDialog/FormDialog.tsx
function k({ open: e, onOpenChange: t, title: n, description: r, hideDescription: i = !1, className: a, submitLabel: o, pendingLabel: s, cancelLabel: c = "Cancel", isPending: u = !1, submitDisabled: _ = !1, tone: v = "default", onSubmit: y, onReset: b, children: x }) {
	let S = w(b);
	S.current = b;
	let D = w(e);
	C(() => {
		D.current && !e && S.current?.(), D.current = e;
	}, [e]);
	function O(e) {
		!e && u || t(e);
	}
	function k(e) {
		e.preventDefault(), e.stopPropagation(), !(u || _) && y();
	}
	return /* @__PURE__ */ T(d, {
		open: e,
		onOpenChange: O,
		children: /* @__PURE__ */ T(f, {
			className: a,
			children: /* @__PURE__ */ E("form", {
				noValidate: !0,
				onSubmit: k,
				className: "flex flex-col gap-4",
				children: [
					/* @__PURE__ */ E(h, { children: [/* @__PURE__ */ T(g, { children: n }), typeof r == "string" ? /* @__PURE__ */ T(p, {
						className: i ? "sr-only" : void 0,
						children: r
					}) : r ? /* @__PURE__ */ T(p, {
						asChild: !0,
						children: /* @__PURE__ */ T("div", {
							className: i ? "sr-only" : void 0,
							children: r
						})
					}) : null] }),
					x,
					/* @__PURE__ */ E(m, { children: [/* @__PURE__ */ T(l, {
						type: "button",
						variant: "outline",
						disabled: u,
						onClick: () => O(!1),
						children: c
					}), /* @__PURE__ */ T(l, {
						type: "submit",
						variant: v === "destructive" ? "destructive" : "default",
						disabled: u || _,
						children: u ? s ?? o : o
					})] })
				]
			})
		})
	});
}
//#endregion
export { D as ConfirmDialog, k as FormDialog, O as HtmlPreviewSheet };

//# sourceMappingURL=index.js.map